// extracted by mini-css-extract-plugin
export default {"noticeBox":"ModalCouponDuplicate_noticeBox__pG91i","modalContent":"ModalCouponDuplicate_modalContent__cJW+k","couponLists":"ModalCouponDuplicate_couponLists__B9oat"};